import { FC } from "react";
import { Link } from "react-router-dom";

import classes from "./NFT.module.css";

interface Props {
  id: string;
  img: string;
}

const NFT: FC<Props> = ({ id, img }) => {
  return (
    <Link to={`/nft?id=${id}`} className={classes.nft}>
      <img src={img} alt="" />
    </Link>
  );
};

export default NFT;
